import React from "react"
import {Table, TableBody, TableCell, TableRow, Typography} from "@mui/material"

import {AccountStatusIcon} from "./AccountStatusIcon"
import {AccountMenuTableCell} from "./AccountMenuTableCell"
import {AccountMenu} from "./AccountMenu"
import {AccountDetails} from "./AccountDetails"

import {OutstandingAccount} from "@indebted/api"

const OutstandingAccountDetails = ({account, reload}: {account: OutstandingAccount; reload: () => void}) => (
	<Table size="small">
		<TableBody>
			<TableRow>
				<TableCell>
					<Typography variant="caption" color="textSecondary" display="block">
						Account Ref
					</Typography>
					<Typography variant="body2" display="block">
						<AccountStatusIcon status="Outstanding" />
						{account.AccountRef}
					</Typography>
				</TableCell>
				<AccountMenuTableCell>
					<AccountMenu account={account} reload={reload} />
				</AccountMenuTableCell>
			</TableRow>
			<AccountDetails
				details={account.Details}
				itemizationBalanceBreakdown={account.ItemizationBalanceBreakdown}
			/>
		</TableBody>
	</Table>
)

export {OutstandingAccountDetails}
